const updates = [
  {
    date: '2026-07-30',
    title: '《盗墓笔记之重启》全集上线',
    desc: '西瓜视频免费专区最新上线热门冒险悬疑剧，高清全集一次性放出，追剧党不可错过。',
  },
  {
    date: '2026-07-29',
    title: '菠萝视频暑期档片单更新',
    desc: '菠萝视频新增30余部暑期热映电影，涵盖动作、喜剧、科幻多种类型，暑期观影指南已更新。',
  },
  {
    date: '2026-07-28',
    title: '青青草视频独播剧《长相思》第二季开播',
    desc: '青青草视频热门古装玄幻剧续作正式开播，首播三集连放，热度持续飙升。',
  },
  {
    date: '2026-07-27',
    title: '神马视频移动端体验全面升级',
    desc: '移动端页面加载速度提升40%，新增夜间模式和记忆播放功能，观影体验更上一层。',
  },
  {
    date: '2026-07-26',
    title: '经典港片修复合集上线',
    desc: '精选50部经典香港电影高清修复版，情怀拉满，带您重温黄金年代的港片记忆。',
  },
  {
    date: '2026-07-25',
    title: '国产动漫专区重磅加更',
    desc: '《斗罗大陆》《凡人修仙传》《完美世界》等热门国漫同步更新，二次元盛宴不间断。',
  },
  {
    date: '2026-07-24',
    title: '韩剧频道新增多部高分神剧',
    desc: '豆瓣8.5分以上韩剧精选合集上线，从经典到新作一网打尽，韩剧迷的宝藏库。',
  },
  {
    date: '2026-07-23',
    title: '智能推荐算法全新升级',
    desc: '基于观影偏好的个性化推荐系统上线，精准匹配您的口味，发现更多潜在好片。',
  },
  {
    date: '2026-07-22',
    title: '纪录片专区正式开放',
    desc: 'BBC、国家地理等顶级纪录片资源入驻，涵盖自然、历史、科技多领域，知识观影新选择。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            神马视频最新动态与片源更新资讯
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200 space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <span className="text-xs text-foreground-400 font-medium mb-1 block">{item.date}</span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}